/**
 * @author Tommy Brière
 * @copyright (c) 2021 Cube Noir
 * @fileoverview a 360 scene. Shoud be a 360 video.
 * */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "@reach/router";

import { LocationLink } from "@utils/data";
import { useRouteData } from "react-static";
import { FloatingPointProps } from "./index.interface";
import { useUrl, useCollect, webGLLeakCrashFix } from "../../utils/navigation";
import { NavigationContext } from "../TransitionRoot/NavigationContext";

/**
 * Point 360 afficher dans la carte aframe
 * Si ça s'affiche on est en mode pleine fonctionnalité
 *
 * @param param0
 * @returns
 */
function FloatingPoint({ point, position, isCollected, lookAt }: FloatingPointProps) {
  const [clicked, setClicked] = useState(false);
  const { lang } = useRouteData();
  const l: LocationLink = { ...point, type: "collectable" };
  const url = useUrl(l);
  const collect = useCollect(l);
  const { goto } = useContext(NavigationContext);

  useEffect(() => {
    async function goAndCollect() {
      if (webGLLeakCrashFix(1)) {
        /* eslint no-restricted-globals: 0 */
        location.href = url;
        return;
      }
      goto(url);
    }

    if (clicked) {
      goAndCollect();
    }
  }, [clicked, collect, goto, url]);

  const handleClick = async (evt) => {
    if (!clicked) {
      setClicked(true);
    }
    evt.preventDefault();
  };

  const handleFocus = (evt) => {
    if (lookAt) {
      lookAt(point.position3D);
    }
  };

  return (
    <Link
      id={point.id}
      to={url}
      onMouseDown={handleClick}
      onClick={handleClick}
      onFocus={handleFocus}
      className={isCollected ? "collected floating-point" : "floating-point"}
      style={position ? { left: position.x, top: position.y } : {}}
    >
      <svg
        data-name="btn_sphere sur la 360"
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className="to-find"
      >
        <g fill="rgba(37,37,37,0)" stroke="#fff" strokeWidth="1">
          <circle cx="20" cy="20" r="20" stroke="none" />
          <circle cx="20" cy="20" r="19.5" fill="none" />
        </g>
        <circle cx="11" cy="11" r="11" transform="translate(9 9)" fill="#ae7a10" opacity="0.35" />
      </svg>
      <img src={require("../../assets/images/artefact.png")} alt="" />

      <div className="overlay">
        <p dangerouslySetInnerHTML={{ __html: point[lang]?.title }} />
      </div>
    </Link>
  );
}

export default FloatingPoint;
